<template>
  <div class="tabs-wrap-card">
    <ul class="tabs">
      <li class="active">
        <a href="#tab_card1">Характеристики</a>
      </li>
    </ul>

    <div :class="tabContainerClass">
      <div class="tab-pane active" :class="tabPaneClass" id="tab_card1">
        <div class="content-info">
          <div class="row">
            <div class="col-md-12">
              <div class="content-info__title">Об объекте:</div>
              <div
                class="card-feature"
                v-for="option of options"
                :key="option.name"
              >
                <span v-text="option.name" />
                <p v-text="`${option.value} ${option.measure}`" />
              </div>
            </div>
          </div>
        </div>
        <ObjectMap v-if="isPrint" :leadId="leadId" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ObjectMap from '@/components/ObjectMap.vue'
export default {
  name: 'InfoTabs',
  props: {
    options: {
      type: Array,
    },
    leadId: {
      type: Number,
      required: false,
    },
  },
  components: {
    ObjectMap,
  },
  computed: {
    ...mapGetters([
      'isPrint',
    ]),
    tabContainerClass() {
      return {
        'tab-container': !this.isPrint,
        'tab-container-print': this.isPrint,
      }
    },
    tabPaneClass() {
      return {
        flex: this.isPrint,
      }
    },
  },
}
</script>

<style scoped>
.tab-container-print {
	position: relative;
	z-index: 2;
	padding: 20px 30px;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(17,28,38,0.07);
	border-radius: 0px 0px 20px 20px;
}
.flex {
  display: flex;
}

@media print {
  .tab-container-print {
    height: 27vh;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .tabs a {
    width: 145px;
    height: 45px;
  }

  .card-feature span {
    width: 150px !important;
    text-overflow: ellipsis;
  }
  .card-feature p {
    width: 200px !important;
    word-wrap: break-word;
  }

  .content-info {
    font-size: 0.8em;
    line-height: 0.9em;
    padding-right: 10px;
  }
}
</style>